"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _acsReportsSdk = require("@adsk/acs-reports-sdk");
var _getRequestConfig = _interopRequireDefault(require("../../../helpers/getRequestConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getHandleReportCreation = _ref => {
  let {
    formValues,
    accountId,
    projectId,
    options,
    beforeSubmit,
    onSubmitComplete,
    onValidateReport,
    onValidationError,
    onError
  } = _ref;
  const requestBody = getRequestBody({
    ...formValues,
    options,
    accountId,
    projectId
  });
  const requestConfig = (0, _getRequestConfig.default)();
  beforeSubmit();
  return onValidateReport(requestBody).then(confirmed => {
    if (confirmed) {
      return (0, _acsReportsSdk.createReport)(requestBody, requestConfig).then(onSubmitComplete).catch(() => {
        onError();
        onSubmitComplete(null);
      });
    } else {
      onValidationError();
    }
  });
};
const getRequestBody = _ref2 => {
  let {
    reportTitle,
    reportService,
    reportType,
    reportFormat,
    reportComponents,
    saveOptions,
    options,
    accountId,
    projectId
  } = _ref2;
  return {
    title: reportTitle,
    service: reportService,
    template: reportType,
    format: reportFormat,
    options: {
      ...options,
      components: reportComponents
    },
    ...(accountId ? {
      accountId
    } : {
      projectId
    }),
    ...(shouldSaveToFiles(saveOptions) && {
      uploadTo: [{
        location: saveOptions.folderUrn,
        saveAsNewFile: saveOptions.saveAsNewFile,
        storage: 'docs'
      }]
    })
  };
};
const shouldSaveToFiles = saveOptions => saveOptions?.checked && saveOptions?.folderUrn;
var _default = exports.default = getHandleReportCreation;